export const DOMAIN_FORMS = "FORMS";
